import React from "react";
import { Check } from "lucide-react";
import { MILESTONES, STATUSES, d, money0, days } from "@/lib/claims";

// Vertical timeline: ● done (with date) · ◉ current pending stage · ○ upcoming
export default function ClaimTimeline({ claim }) {
  const curIdx = STATUSES.indexOf(claim.current_status);
  const paid = claim.current_status === STATUSES[STATUSES.length - 1] && claim.payment_received_date;
  return (
    <ol className="relative" data-testid="claim-timeline">
      {MILESTONES.map((m, i) => {
        const date = claim[m.date];
        const stageIdx = m.status ? STATUSES.indexOf(m.status) : -1;
        const isCurrent = m.status === claim.current_status && !paid;
        const done = m.key === "accident" ? !!date : stageIdx < curIdx || (stageIdx === curIdx && !!date && (m.key !== "paid" || paid)) || (m.key === "paid" && paid);
        const last = i === MILESTONES.length - 1;
        return (
          <li key={m.key} className={`relative flex gap-3 ${last ? "" : "pb-3"}`} data-testid={`timeline-${m.key}`} data-state={done ? "done" : isCurrent ? "current" : "todo"}>
            {!last && <span className={`absolute left-[8px] top-5 bottom-0 w-px ${done ? "bg-emerald-500/50" : "bg-slate-800"}`} />}
            <span className={`relative z-10 mt-0.5 w-[17px] h-[17px] rounded-full grid place-items-center shrink-0 border-2 ${done ? "bg-emerald-500 border-emerald-400 text-slate-950" : isCurrent ? "bg-rose-500/20 border-rose-400 ring-4 ring-rose-500/15" : "bg-[#151D2E] border-slate-700"}`}>
              {done && <Check className="w-2.5 h-2.5" strokeWidth={3} />}{isCurrent && <span className="w-1.5 h-1.5 rounded-full bg-rose-400 animate-pulse" />}
            </span>
            <div className="min-w-0 flex-1 flex items-baseline justify-between gap-2 flex-wrap">
              <div className="min-w-0">
                <span className={`text-sm font-semibold ${done ? "text-slate-100" : isCurrent ? "text-rose-200" : "text-slate-500"}`}>{m.label}</span>
                <span className={`block sm:inline sm:ml-2 text-xs font-mono-num ${done ? "text-slate-400" : isCurrent ? "text-rose-300" : "text-slate-600"}`}>
                  {date ? d(date) : done ? "Done · date not recorded" : isCurrent ? `Pending · ${days(claim.aging?.days_at_stage ?? 0)} at this stage` : "Pending"}
                </span>
              </div>
              {m.amount && claim[m.amount] != null && <span className="font-mono-num text-xs text-slate-300 shrink-0">{money0(claim[m.amount])}</span>}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
